import { createSlice } from "@reduxjs/toolkit";
//#region ../src/state/recording-slice.ts
const recordingSlice = createSlice({
	name: "recording",
	initialState: {
		isRecording: false,
		sessionMetadata: null,
		actionCount: 0,
		failedWriteCount: 0,
		latestDepthSample: null
	},
	reducers: {
		startSession(state, action) {
			const { scenarioName, contextTag, ...rest } = action.payload;
			state.isRecording = true;
			state.sessionMetadata = {
				...rest,
				contextTag: contextTag ?? scenarioName ?? ""
			};
			state.actionCount = 0;
			state.failedWriteCount = 0;
			state.latestDepthSample = null;
		},
		endSession(state) {
			state.isRecording = false;
		},
		/**
		* Record a depth sample from WebXR depth sensing.
		* The sample includes camera pose and a grid of depth points.
		* This action is persisted to enable replay with depth data.
		*
		* The reducer stores only the LATEST sample (observation hook for
		* subscribers like the occupancy-grid wiring); it applies no
		* coordinate conversion — the payload stays raw WebXR, exactly as
		* persisted.
		*/
		recordDepthSample(state, action) {
			state.latestDepthSample = action.payload;
		},
		/**
		* Record a write failure during persistence.
		* User Feedback Issue #1 Part B: Track write failures for session summary.
		*/
		recordWriteFailure(state, _action) {
			state.failedWriteCount += 1;
		}
	}
});
const { startSession, endSession, recordDepthSample, recordWriteFailure } = recordingSlice.actions;
const recordingReducer = recordingSlice.reducer;
//#endregion
export { endSession, recordDepthSample, recordWriteFailure, recordingReducer, startSession };
